import { render, staticRenderFns } from "./MinisiteResults.vue?vue&type=template&id=76c2b2ae&"
import script from "./MinisiteResults.vue?vue&type=script&lang=js&"
export * from "./MinisiteResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c2b2ae')) {
      api.createRecord('76c2b2ae', component.options)
    } else {
      api.reload('76c2b2ae', component.options)
    }
    module.hot.accept("./MinisiteResults.vue?vue&type=template&id=76c2b2ae&", function () {
      api.rerender('76c2b2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteResults.vue"
export default component.exports